module.exports = __webpack_public_path__ + "img/smile3.1.e9f62fef.svg";